import { IconButton, InputAdornment, TextField } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { useTranslation } from 'react-i18next';

interface SearchInputProps {
  readonly id: string;
  readonly inputRef: React.RefObject<HTMLInputElement | null>;
  readonly onChange: (search: string) => void;
  readonly onSubmit: (search: string) => void;
  readonly dense?: boolean;
  readonly helperText?: string;
  readonly error?: boolean;
}

export default function SearchInput({
  id,
  inputRef,
  onChange,
  onSubmit,
  dense = false,
  helperText,
  error,
}: SearchInputProps) {
  const { t } = useTranslation();
  const showSubmitButton = dense;

  function handleSubmit(event?: React.FormEvent) {
    if (event) {
      event.preventDefault();
    }
    onSubmit(inputRef.current?.value ?? '');
  }

  function handleOnChange(event: React.ChangeEvent<HTMLInputElement>) {
    onChange(event.target.value);
  }

  return (
    <TextField
      id='search-input'
      label={t('search.searchTerm.label')}
      variant='outlined'
      helperText={helperText}
      error={error}
      fullWidth
      autoComplete='off'
      autoFocus
      size={dense ? 'small' : 'medium'}
      onChange={handleOnChange}
      inputRef={inputRef}
      InputProps={{
        id,
        sx: { paddingRight: 0, backgroundColor: 'background.paper' },
        endAdornment: !showSubmitButton ? undefined : (
          <InputAdornment position='end'>
            <IconButton
              onClick={handleSubmit}
              sx={{
                height: '43px',
                width: '43px',
              }}
            >
              <SearchIcon />
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  );
}
